import { useMemo, useState, type MutableRefObject } from 'react';
import { hoverZoom, type Transform, type Config, configKeys } from './helpers/hoverZoom';
import { filterUndefined } from './helpers/typescriptFunctions';

type HoverZoomReturn = ReturnType<typeof hoverZoom>;
type Return = HoverZoomReturn & { transform: Transform; canZoom: boolean };

export const useHoverZoom = (
    imgRef: MutableRefObject<HTMLImageElement | null>,
    config?: Config
): Return => {
    const [transform, setTransform] = useState<[x: number, y: number, scale: number] | null>(null);
    const [canZoom, setCanZoom] = useState(false);

    // destructure to allow for value use in dependency array
    const { maxScale, maxSize, movementScale } = config || {};

    const { handleMouseMove, handleZoom, handleLoad } = useMemo(() => {
        const reConfig: Config = { maxScale, maxSize, movementScale };
        const filteredConfig = filterUndefined(reConfig, configKeys);
        return hoverZoom(imgRef, setTransform, setCanZoom, filteredConfig);
    }, [imgRef, maxScale, maxSize, movementScale]);

    return {
        handleMouseMove,
        handleZoom,
        transform,
        handleLoad,
        canZoom,
    };
};
